import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import CommonLoader from '../../../components/common/commonLoader'
import { useAuthStore } from '../../../store/authStore'
import { useDomainManageStore } from '../../../store/domainManageStore'

export default function ImpersonateLogin() {
  const {
    setImpersonating,
    setToken,
    setUserData,
    setAuthenticated,
    setIsSuperUser,
    setOrgImpersonating,
    setAssessorImpersonating,
    setImpersonatorId,
  } = useAuthStore()
  const { domainType } = useDomainManageStore()
  const navigate = useNavigate()

  const urlParams = new URLSearchParams(window.location.search)

  const tokenId = urlParams.get('token')
  const userId = urlParams.get('userId')
  const name = urlParams.get('name')
  const impersonator_id = urlParams.get('impersonator_id')

  useEffect(() => {
    if (userId && tokenId) {
      localStorage.setItem('shouldReload', 'false')
      impersonator_id && setImpersonatorId(impersonator_id)
      setImpersonating(true)
      domainType === 'Organisation' && setOrgImpersonating(true)
      domainType === 'Assessor' && setAssessorImpersonating(true)
      setToken(tokenId)
      setAuthenticated(true)
      setUserData({
        id: userId,
        is_admin: false,
        name: `${name}`,
      })
      setIsSuperUser(false)
      localStorage.setItem('shouldReload', 'true')
    }
  }, [userId, tokenId])

  useEffect(() => {
    setTimeout(() => {
      if (domainType === 'Organisation') {
        navigate(`/myorganisation/profile`)
      } else if (domainType === 'Assessor') {
        navigate('/assessors')
      }
    }, 1000)
  }, [domainType])

  return (
    <div>
      <CommonLoader />
    </div>
  )
}
